const CLOSE_BUTTON_SELECTOR = 'data-flash-message-close-button';
export class FlashMessages {
    constructor(message) {
        this.handleClickEvent = (event) => {
            event.stopPropagation();
            this.closeMessage();
        };
        this.message = message;
        this.closeButton = this.getCloseButton();
        this.bindEvents();
    }
    bindEvents() {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.handleClickEvent);
        }
    }
    getCloseButton() {
        return this.message.querySelector(`[${CLOSE_BUTTON_SELECTOR}]`);
    }
    closeMessage() {
        this.message.classList.add('hidden');
    }
}
